import { Utils } from "@formio/react";
import moment from "moment";

export function forEachInputComponent(components, callback) {
  Utils.eachComponent(
    components,
    (comp) => {
      if (comp.input) callback(comp);

      if (comp.type === "columns") {
        Utils.eachComponent(comp.columns, callback, true);
      }
    },
    true
  );
}

export function applyAutoDate(component, submission) {
  if (!submission[component.key]) {
    const value = moment().format("YYYY-MM-DD HH:mm:ss");
    component.defaultValue = value;
    submission[component.key] = value;
  }
}

export async function getCurrentLocation() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
}